import { useSelector } from "react-redux";
import { RootState } from "src/redux/reducers";

interface Props {
  amount: number | string;
  className?: string;
}

export const CurrencyAmount: React.FC<Props> = ({ amount, className }) => {
  let position = useSelector(
    ({ currencyData }: RootState) => currencyData.myCurrencyData?.symbolPosition
  );
  const symbol = useSelector(
    ({ currencyData }: RootState) => currencyData.myCurrencyData?.symbol ?? 'Rs.'
  );
  return (
    <span className={className} style={{ display: 'inline-flex', flexDirection: 'row', gap: '4px' }}>
      {position === 'before' && <span>{symbol}</span>}
      <span>{Number(amount)}</span>
      {position === 'after' && <span>{symbol}</span>}
    </span>
  );
};
